import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from'rxjs';

@Injectable({ providedIn: 'root' })
export class DynamicHeaderService {
	data: any;
	private subject = new Subject<any>();
	constructor() { }

	setDynamicHeader(header: any) {
		this.data = header;
		this.subject.next(header);
	}

	getDynamicHeader(): Observable<any> {
		return this.subject.asObservable();
	}

}
